import '@/sass/main.scss';

import $ from 'jquery';
let Macy = require('macy');
let Intense = require('@tholman/intense-images');


$(document).ready(() => {
    // assign random class for image fade in
    let photos = $('.homepage-grid__photo');
    photos.each((index, element) => {
        let fadeInNumber = Math.floor(Math.random() * 3);
        $(element).addClass('fade-in-' + fadeInNumber)
    });


    // image grid
    let macy = Macy({
        container: '#macy-container',
        trueOrder: false,
        waitForImages: true,
        margin: 24,
        columns: 4,
        breakAt: {
            940: 3,
            520: 2,
            400: 1
        }
    });

    $('.button').on('click', function() {
        $('.content').toggleClass('isOpen');
      });

    // intense image modal
    // var photos = document.querySelectorAll( '.homepage-grid__photo' );
    Intense( photos );
});



// WEBPACK FOOTER //
// ./static/js/main.js